import React from 'react';
import { Navigate } from 'react-router-dom';
import { isAdmin } from '../../utils/admin-utils';

interface ProtectedAdminRouteProps {
  children: React.ReactNode;
}

/**
 * Protected route component that checks if user has admin access
 * Redirects to home if user is not an admin
 */
const ProtectedAdminRoute: React.FC<ProtectedAdminRouteProps> = ({ children }) => {
  // Check if the user is admin using originalAdminCBID
  const hasAdminAccess = isAdmin();
    
  if (!hasAdminAccess) {
    // Redirect to home if user is not an admin
    return <Navigate to="/home" replace />;
  }
  
  return <>{children}</>;
};

export default ProtectedAdminRoute;
